import {AppComponent} from "./app.component";
import {NgModule,} from "@angular/core";
import {HashLocationStrategy, LocationStrategy, PathLocationStrategy} from "@angular/common";
import {AppRoutingModule} from "./app-routing.module";
import {BrowserModule} from "@angular/platform-browser";
import {CoreModule} from "./core/core.module";
import {DsModule} from "./ds/ds.module";
import {ObModule} from "./ob/ob.module";
import {RgModule} from "./rg/rg.module";
import {UsModule} from "./us/us.module";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthInterceptor} from "./core/auth/auth.interceptor";
import {QRCodeModule} from "angularx-qrcode";
import {CiModule} from "./ci/ci.module";
import {ConfirmationService, MessageService} from "primeng/api";
import {ToastModule} from "primeng/toast";
import {CsModule} from "./cs/cs.module";
import {ConfirmDialogModule} from "primeng/confirmdialog";

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, AppRoutingModule, CoreModule, DsModule, ObModule, RgModule, CsModule, UsModule, CiModule, QRCodeModule, ToastModule, ConfirmDialogModule,],
  providers: [MessageService,ConfirmationService,
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



